import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
import React from 'react';
import ReactDOM from 'react-dom/client';
import TagManager from 'react-gtm-module';
import App from './App';
import { makeMockServer } from './__mock__/server.mock';
import { log } from './common/utils/logger';
import './index.css';
import reportWebVitals from './reportWebVitals';
import './setupTestMocks';

if (process.env.REACT_APP_TAG) {
  log(`Deployed tag %c${process.env.REACT_APP_TAG}`, 'curiousBlue');
}

if (process.env.REACT_APP_GTM_ID) {
  // Initialize google tag manager
  TagManager.initialize({
    gtmId: process.env.REACT_APP_GTM_ID
  });
}

if (process.env.REACT_APP_MOCK) {
  makeMockServer({ environment: process.env.NODE_ENV });
}

(async () => {
  const LDProvider = await asyncWithLDProvider({
    clientSideID: process.env.REACT_APP_LD_CLIENT_ID,
    options: {
      bootstrap: 'localStorage'
    }
  });

  const root = ReactDOM.createRoot(document.getElementById('root'));

  root.render(
    <LDProvider>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </LDProvider>
  );
})();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
